import { Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PlusIcon from "../../../components/ui/icons/Plus";
import FutureBotImg from "../assets/futures-grid-bot-img.png";
import StrategyBotImg from "../assets/strategy-img.png";
import Text from "../../../_components/Text";
import { myT } from "../../../_i18n/utils";

type BotType = "futures" | "auto-strategies";

const BOT_IMAGES: Record<BotType, string> = {
  futures: FutureBotImg,
  "auto-strategies": StrategyBotImg,
};

const getBotText = (type: BotType): string => {
  switch (type) {
    case "futures":
      return myT("futuresBot", "navBar");
    case "auto-strategies":
      return myT("autoStrategy", "navBar");
    default:
      return "";
  }
};

interface BotTypeCardProps {
  type: BotType;
}

const BotTypeCard = ({ type }: BotTypeCardProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.grey[400],
        paddingBottom: "0px",
        paddingTop: "2px",
        paddingRight: "16px",
        position: "relative",
        borderRadius: "16px",
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Box paddingLeft="8px">
          <img src={BOT_IMAGES[type]} style={{ height: 75, display: "block" }} alt="" />
        </Box>

        <Text variant="h3" sx={{ marginRight: "auto" }}>
          {getBotText(type)}
        </Text>

        <PlusIcon size={18} />
      </Stack>
    </Box>
  );
};

export default BotTypeCard;
